import { render } from "./IconDollarColored.vue?vue&type=template&id=57a40558"
import script from "./IconDollarColored.vue?vue&type=script&lang=js"
export * from "./IconDollarColored.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__